import {actionNames} from 'constants/index';
const actions ={};

actions.SOLICITUD_EMPADRONAMIENTO_SET_STEP_PORTAL_WEB =(state)=>{
    return { type:actionNames.SOLICITUD_EMPADRONAMIENTO_SET_STEP_PORTAL_WEB, state};
}
actions.SOLICITUD_EMPADRONAMIENTO_SET_RECHAZAR_SOLICITUD_PORTAL_WEB =(state)=>{
    return { type:actionNames.SOLICITUD_EMPADRONAMIENTO_SET_RECHAZAR_SOLICITUD_PORTAL_WEB, state};
}
actions.SOLICITUD_EMPADRONAMIENTO_SET_DATOS_PORTAL_WEB =(state)=>{
    return { type:actionNames.SOLICITUD_EMPADRONAMIENTO_SET_DATOS_PORTAL_WEB, state};
}
actions.SOLICITUD_EMPADRONAMIENTO_SET_CUI_DPI_PORTAL_WEB =(state)=>{
    return { type:actionNames.SOLICITUD_EMPADRONAMIENTO_SET_CUI_DPI_PORTAL_WEB, state};
}
actions.SET_RESIDENCIA_ACTUAL_PADRON =(state)=>{
    return { type:actionNames.SET_RESIDENCIA_ACTUAL_PADRON, state};
}
export default actions;